import ElementPlus from 'element-plus'
import '../element-variables.scss'
import {App} from "@vue/runtime-core";
import locale  from 'element-plus/es/locale/lang/zh-cn'
export default (app:App<Element>) => {
  app.use(ElementPlus,{
    locale
  })
}
